import GridPlaceholder from './GridPlaceholder';

export default GridPlaceholder;
